import styled from "@emotion/styled";
import KeyIcon from '@mui/icons-material/Key';

export const DlspPermissionIcon = styled(KeyIcon)(({theme}) => ({
    "&.Yes": {
        color: theme.palette.statusComplete.main,
    },
}));